import React, { Component, useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { Link, useNavigate, useHistory } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import CohortCreateComponent from "./CohortCreate/component";
import ConfigurepayoutComponent from "./component";
import { onChange_CreateCohortSuccess } from "./action";
import { onChange_CreateFranchiseeSuccess } from "./action";
import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

export const steps = [
  "Create a Cohort",
  "Create a Franchise",
  "Map Charges",
  "Add Franchise Bank Details",
];

const ConfigurepayoutContainer = (props) => {
  const [activeStep, setActiveStep] = useState(0);
  const [stepCompleted, setStepCompleted] = useState(
    Array(steps.length).fill(false)
  );
  const [createCohortCalled, setCreateCohortCalled] = useState(false);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [createFranchiseeCharges, setCreateFranchiseeCharges] = useState(null);
  const [franchiseeId, setFranchiseeId] = useState(null);
  const [cohortId, setCohortId] = useState(null);
  const [createFranchiseeCalled, setCreateFranchiseeCalled] = useState(false);
  const [selectedChargeIds, setSelectedChargeIds] = useState([]);
  const [warehouseList, setWarehouseList] = useState();

  const [formData, setFormData] = useState({
    name: "",
    areaName: "",
    description: "",
    latitude: "",
    longitude: "",
    cohortTypeId: "",
    vmIDs: "",
    userID: "",
    machines: [],
  });
  const [formDataFranchisee, setFormDataFranchisee] = useState({
    name: "",
    description: "",
    // type: "",
    cohortId: "",
    ownerId: "",
    warehouseId: "",
    cohortTypeId: "" // Added cohortTypeId field
  });

  const [formDataBank, setFormDataBank] = useState({
    accountName: "",
    accountId: "",
    ifsc: "",
    vpaId: "",
  });

  console.log("franchiseeCharges", createFranchiseeCharges);

  const handleNext = async () => {
    let isValid = true;
  
    if (activeStep === 0) {
      isValid = validateCohortFields();
      if (!isValid) {
        toastr.error(
          "Error",
          "Please Enter All Required Fields to Create a Cohort"
        );
        return;
      }
      const success = await handleCreateCohort(); 
      if (!success) return; 
    } else if (activeStep === 1) {
      isValid = validateFranchiseeFields();
      if (!isValid) {
        toastr.error(
          "Error",
          "Please Enter All Required Fields to Create a Franchisee"
        );
        return;
      }
      const success = await handleCreateFranchisee();
      if (!success) return; 
    } else if (activeStep === 2) {
      if (selectedChargeIds.length === 0) {
        toastr.error("Error", "Please Select at least one Charge to Proceed");
        return;
      }
      const success = await handleAssignCharges(); 
      if (!success) return; 
    } else if (activeStep === 3) {
      isValid = validateBankDetailsFields();
      if (!isValid) {
        toastr.error(
          "Error",
          "Please Enter All Required Fields to Create Bank Details"
        );
        return;
      }
      const success = await handleBankDetails(); 
      if (!success) return; 
    }
  
    setActiveStep((prevStep) => prevStep + 1);
  };

  const validateCohortFields = () => {
    const requiredFields = [
      "name",
      "areaName",
      "description",
      "cohortTypeId",
      "longitude",
      "latitude",
      "vmIDs",
      "userID",
    ];
    let isValid = true;

    const newErrors = { ...errors };

    requiredFields.forEach((field) => {
      if (formData[field].trim() === "") {
        newErrors[field] = `${
          field.charAt(0).toUpperCase() + field.slice(1)
        } is required`;
        isValid = false;
      } else {
        newErrors[field] = "";
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  const validateFranchiseeFields = () => {
    const requiredFranchiseeFields = ["name", "description", "ownerId",  "warehouseId", "cohortTypeId"]; // Added cohortTypeId
    let isValid = true;

    const newErrors = {};

    requiredFranchiseeFields.forEach((field) => {
      if (!formDataFranchisee[field]) {
        newErrors[field] = `${
          field.charAt(0).toUpperCase() + field.slice(1)
        } is required`;
        isValid = false;
      } else {
        newErrors[field] = "";
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  const validateBankDetailsFields = () => {
    const requiredFields = ["accountName", "accountId", "ifsc"];
    let isValid = true;

    const newErrors = { ...errors };

    requiredFields.forEach((field) => {
      if (formDataBank[field].trim() === "") {
        newErrors[field] = `${
          field.charAt(0).toUpperCase() + field.slice(1)
        } is required`;
        isValid = false;
      } else {
        newErrors[field] = "";
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  const handleClose = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleChangeCohort = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleChangeFranchisee = (event) => {
    const { name, value } = event.target;
    setFormDataFranchisee((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleCreateCohort = async () => {
    validateCohortFields();
    console.log("handleCreateCohort function called");
  
    const cohortTypeId = parseInt(formData.cohortTypeId);
    const latitude = parseFloat(formData.latitude);
    const longitude = parseFloat(formData.longitude);
    const userID = formData.userID.split(",").map(Number);
  
    const vmIDsArray = formData.vmIDs
      .split(",")
      .map((item) => parseInt(item.trim(), 10))
      .filter((item) => !isNaN(item));
  
    const payload = {
      name: formData.name,
      areaName: formData.areaName,
      description: formData.description,
      lat: isNaN(latitude) ? null : latitude,
      lng: isNaN(longitude) ? null : longitude,
      cohortTypeId: isNaN(cohortTypeId) ? null : cohortTypeId,
      vmCollection: vmIDsArray,
      userIdCollection: userID.filter((id) => !isNaN(id)),
    };
  
    return new Promise((resolve) => {
      props.getDataFromAPI(
        `/dashboard/api/v2/admin/vendingmachines/vm-cohorts`,
        "POST",
        payload,
        (response) => {
          console.log("API success response:", response);
  
          if (response.cohortId !== undefined) {
            console.log("Cohort success:", response);
            props.onChange_CreateCohortSuccess(response);
            toastr.success("Success", "Cohort created successfully");
  
            setCohortId(response.cohortId);
            resolve(true); 
          } else {
            toastr.error("Error", "Failed to create cohort");
            resolve(false); 
          }
        },
        (err) => {
          console.error("API error response:", err);
          toastr.error("Error", err?.message );
          resolve(false); 
        }
      );
    });
  };

  const handleCreateFranchisee = async () => {
    validateFranchiseeFields();
    console.log("Creating franchisee...");
    const cohortIdValue =
      formDataFranchisee.cohortId !== ""
        ? parseInt(formDataFranchisee.cohortId)
        : cohortId;
  
    const payload = {
      name: formDataFranchisee.name,
      description: formDataFranchisee.description,
      // type: formDataFranchisee.type,
      cohortId: cohortIdValue,
      ownerId: parseInt(formDataFranchisee.ownerId),
      warehouseId: formDataFranchisee.warehouseId ? parseInt(formDataFranchisee.warehouseId) : null,
      cohortTypeId: formDataFranchisee.cohortTypeId ? parseInt(formDataFranchisee.cohortTypeId) : null // Added cohortTypeId to payload
    };
  
    return new Promise((resolve) => {
      props.getDataFromAPI(
        `/dashboard/api/v2/admin/franchisee`,
        "POST",
        payload,
        (response) => {
          console.log("Franchisee creation response:", response);
  
          if (response.id) {
            const franchiseeId = response.id;
            console.log("Franchisee ID:", franchiseeId);
            toastr.success("Success", "Franchisee created successfully");
  
            setFranchiseeId(franchiseeId);
            resolve(true); 
          } else {
            toastr.error("Error", "Failed to create franchisee");
            resolve(false);
          }
        },
        (err) => {
          console.error("Error creating franchisee:", err);
          toastr.error("Error", err?.message || "An error occurred");
          resolve(false); 
        }
      );
    });
  };

  const handleGetMapCharges = () => {
    const queryParams = new URLSearchParams({
      pageSize: 100,
      pageNumber: 0,
      beneficiaryTypeId: 1,
    });

    const url = `/dashboard/api/v2/admin/platform/charge?${queryParams.toString()}`;

    props.getDataFromAPI(
      url,
      "GET",
      undefined,
      (response) => {
        console.log("Franchisee charges response:", response);
        setCreateFranchiseeCharges(response);
      },
      (err) => {
        console.log("error---", err);
        toastr.error("Failed", "Unable to fetch franchisee details");
      }
    );
  };

  const handleCheckboxChange = (chargeId) => {
    if (selectedChargeIds.includes(chargeId)) {
      setSelectedChargeIds(selectedChargeIds.filter((id) => id !== chargeId));
    } else {
      setSelectedChargeIds([...selectedChargeIds, chargeId]);
    }
  };

  useEffect(() => {
    if (activeStep === 2 && !createFranchiseeCharges) {
      handleGetMapCharges();
    }

    if (activeStep === 2 && createFranchiseeCharges) {
      setSelectedChargeIds([]);
    }
  }, [activeStep, createFranchiseeCharges]);

  const handleAssignCharges = async () => {
    if (!franchiseeId) {
      toastr.error("Error", "Franchisee ID is not available.");
      return false; 
    }
  
    const payload = selectedChargeIds;
  
    return new Promise((resolve) => {
      try {
        props.getDataFromAPI(
          `/dashboard/api/v2/admin/platform/beneficiary/franchisee/${franchiseeId}/charge`,
          "POST",
          payload,
          (response) => {
            console.log("handleAssignCharges API response:", response);
  
            setFranchiseeId(franchiseeId); 
            toastr.success("Charges Applied Successfully!");
            resolve(true); 
          },
          (err) => {
            console.error("handleAssignCharges API error:", err.message);
            toastr.error("Error", err.message || "Failed to assign charges.");
            resolve(false); 
          }
        );
      } catch (err) {
        console.error("Unexpected error assigning charges:", err);
        toastr.error("Error", "An unexpected error occurred.");
        resolve(false); 
      }
    });
  };

  const handleBankDetails = async () => {
    if (!validateBankDetailsFields()) {
      return false;
    }

    return new Promise((resolve) => {
      try {
        const payload = {
          accountName: formDataBank.accountName,
          accountId: formDataBank.accountId,
          ifsc: formDataBank.ifsc,
        };

        props.getDataFromAPI(
          `/dashboard/api/v2/admin/franchisee/${franchiseeId}/bank-detail`,
          "PUT",
          payload,
          (response) => {
            console.log("bank details creation response:", response);
            setFranchiseeId(response.id);
            toastr.success("Success", "Partner Created Successfully");
            navigate("/home/configuration/managepartners");
            resolve(true);
          },
          (err) => {
            console.log("Error creating bank details:", err);
            toastr.error("Error", err?.message || "Failed to create bank details");
            resolve(false);
          }
        );
      } catch (err) {
        console.log("Unexpected error:", err);
        toastr.error("Error", "An unexpected error occurred");
        resolve(false);
      }
    });
  };

  useEffect(() => {
    getWarehouseList();
  }, []);

  const getWarehouseList = () => {
    props.getDataFromAPI(
      "/partner/api/v2/warehouse/list",
      "GET",
      undefined,
      (response) => {
        console.log("warehouseData:", response);
        setWarehouseList(response);
      },
      (err) => {
        console.log("error:", err);
        toastr.error("Failed", "Unable to fetch warehouse listing");
      }
    );
  };

  const handleChangeBankDetails = (event) => {
    const { name, value } = event.target;
    setFormDataBank((prevData) => ({ ...prevData, [name]: value }));
  };

  return (
    <>
      <ConfigurepayoutComponent
        activeStep={activeStep}
        handleNext={handleNext}
        handleClose={handleClose}
        handleCreateCohort={handleCreateCohort}
        formData={formData}
        handleChangeCohort={handleChangeCohort}
        setFormData={setFormData}
        handleCreateFranchisee={handleCreateFranchisee}
        setFormDataFranchisee={setFormDataFranchisee}
        handleChangeFranchisee={handleChangeFranchisee}
        errors={errors}
        createFranchiseeCharges={createFranchiseeCharges}
        createCohortCalled={createCohortCalled}
        handleAssignCharges={handleAssignCharges}
        handleBankDetails={handleBankDetails}
        cohortId={cohortId}
        handleChangeBankDetails={handleChangeBankDetails}
        formDataBank={formDataBank}
        handleCheckboxChange={handleCheckboxChange}
        selectedChargeIds={selectedChargeIds}
        franchiseeId={franchiseeId}
        stepCompleted={stepCompleted}
        warehouseList={warehouseList}
      />
    </>
  );
};

function mapStateToProps(props) {
  return {
    props,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
  onChange_CreateCohortSuccess,
  onChange_CreateFranchiseeSuccess,
})(ConfigurepayoutContainer);


// import React, { Component, useEffect, useState, useRef } from "react";
// import { connect } from "react-redux";
// import { getDataFromAPI } from "../../../HandleAPICalls/actions";
// import { Link, useNavigate, useHistory } from "react-router-dom";
// import { toastr } from "react-redux-toastr";
// import CohortCreateComponent from "./CohortCreate/component";
// import ConfigurepayoutComponent from "./component";
// import { onChange_CreateCohortSuccess } from "./action";
// import { onChange_CreateFranchiseeSuccess } from "./action";
// import { ToastContainer, toast } from "react-toastify";

// import "react-toastify/dist/ReactToastify.css";

// export const steps = [
//   "Create a Cohort",
//   "Create a Franchise",
//   "Map Charges",
//   "Add Franchise Bank Details",
// ];

// const ConfigurepayoutContainer = (props) => {
//   const [activeStep, setActiveStep] = useState(0);
//   const [stepCompleted, setStepCompleted] = useState(
//     Array(steps.length).fill(false)
//   );
//   const [createCohortCalled, setCreateCohortCalled] = useState(false);
//   const navigate = useNavigate();
//   const [errors, setErrors] = useState({});
//   const [createFranchiseeCharges, setCreateFranchiseeCharges] = useState(null);
//   const [franchiseeId, setFranchiseeId] = useState(null);
//   const [cohortId, setCohortId] = useState(null);
//   const [createFranchiseeCalled, setCreateFranchiseeCalled] = useState(false);
//   const [selectedChargeIds, setSelectedChargeIds] = useState([]);
//   const [warehouseList,setWarehouseList] = useState();

//   const [formData, setFormData] = useState({
//     name: "",
//     areaName: "",
//     description: "",
//     latitude: "",
//     longitude: "",
//     cohortTypeId: "",
//     vmIDs: "",
//     userID: "",
//     machines: [],
//   });
//   const [formDataFranchisee, setFormDataFranchisee] = useState({
//     name: "",
//     description: "",
//     type: "",
//     cohortId: "",
//     ownerId: "",
//     warehouseId: "" 
//   });

//   const [formDataBank, setFormDataBank] = useState({
//     accountName: "",
//     accountId: "",
//     ifsc: "",
//     vpaId: "",
//   });

//   console.log("franchiseeCharges", createFranchiseeCharges);

//   const handleNext = async () => {
//     let isValid = true;
  
//     if (activeStep === 0) {
//       isValid = validateCohortFields();
//       if (!isValid) {
//         toastr.error(
//           "Error",
//           "Please Enter All Required Fields to Create a Cohort"
//         );
//         return;
//       }
//       const success = await handleCreateCohort(); 
//       if (!success) return; 
//     } else if (activeStep === 1) {
//       isValid = validateFranchiseeFields();
//       if (!isValid) {
//         toastr.error(
//           "Error",
//           "Please Enter All Required Fields to Create a Franchisee"
//         );
//         return;
//       }
//       const success = await handleCreateFranchisee();
//       if (!success) return; 
//     } else if (activeStep === 2) {
//       if (selectedChargeIds.length === 0) {
//         toastr.error("Error", "Please Select at least one Charge to Proceed");
//         return;
//       }
//       const success = await handleAssignCharges(); 
//       if (!success) return; 
//     } else if (activeStep === 3) {
//       isValid = validateBankDetailsFields();
//       if (!isValid) {
//         toastr.error(
//           "Error",
//           "Please Enter All Required Fields to Create Bank Details"
//         );
//         return;
//       }
//       const success = await handleBankDetails(); 
//       if (!success) return; 
//     }
  
//     setActiveStep((prevStep) => prevStep + 1);
//   };

//   const validateCohortFields = () => {
//     const requiredFields = [
//       "name",
//       "areaName",
//       "description",
//       "cohortTypeId",
//       "longitude",
//       "latitude",
//       "vmIDs",
//       "userID",
//     ];
//     let isValid = true;

//     const newErrors = { ...errors };

//     requiredFields.forEach((field) => {
//       if (formData[field].trim() === "") {
//         newErrors[field] = `${
//           field.charAt(0).toUpperCase() + field.slice(1)
//         } is required`;
//         isValid = false;
//       } else {
//         newErrors[field] = "";
//       }
//     });

//     setErrors(newErrors);
//     return isValid;
//   };

//   const validateFranchiseeFields = () => {
//     const requiredFranchiseeFields = ["name", "description", "ownerId", "type","warehouseId"];
//     let isValid = true;

//     const newErrors = {};

//     requiredFranchiseeFields.forEach((field) => {
//       if (!formDataFranchisee[field]) {
//         newErrors[field] = `${
//           field.charAt(0).toUpperCase() + field.slice(1)
//         } is required`;
//         isValid = false;
//       } else {
//         newErrors[field] = "";
//       }
//     });

//     setErrors(newErrors);
//     return isValid;
//   };

//   const validateBankDetailsFields = () => {
//     const requiredFields = ["accountName", "accountId", "ifsc"];
//     let isValid = true;

//     const newErrors = { ...errors };

//     requiredFields.forEach((field) => {
//       if (formDataBank[field].trim() === "") {
//         newErrors[field] = `${
//           field.charAt(0).toUpperCase() + field.slice(1)
//         } is required`;
//         isValid = false;
//       } else {
//         newErrors[field] = "";
//       }
//     });

//     setErrors(newErrors);
//     return isValid;
//   };

//   const handleClose = () => {
//     setActiveStep((prevStep) => prevStep - 1);
//   };

//   const handleChangeCohort = (event) => {
//     const { name, value } = event.target;
//     setFormData((prevData) => ({ ...prevData, [name]: value }));
//   };

//   const handleChangeFranchisee = (event) => {
//     const { name, value } = event.target;
//     setFormDataFranchisee((prevData) => ({ ...prevData, [name]: value }));
//   };

//   const handleCreateCohort = async () => {
//     validateCohortFields();
//     console.log("handleCreateCohort function called");
  
//     const cohortTypeId = parseInt(formData.cohortTypeId);
//     const latitude = parseFloat(formData.latitude);
//     const longitude = parseFloat(formData.longitude);
//     const userID = formData.userID.split(",").map(Number);
  
//     const vmIDsArray = formData.vmIDs
//       .split(",")
//       .map((item) => parseInt(item.trim(), 10))
//       .filter((item) => !isNaN(item));
  
//     const payload = {
//       name: formData.name,
//       areaName: formData.areaName,
//       description: formData.description,
//       lat: isNaN(latitude) ? null : latitude,
//       lng: isNaN(longitude) ? null : longitude,
//       cohortTypeId: isNaN(cohortTypeId) ? null : cohortTypeId,
//       vmCollection: vmIDsArray,
//       userIdCollection: userID.filter((id) => !isNaN(id)),
//     };
  
//     return new Promise((resolve) => {
//       props.getDataFromAPI(
//         `/dashboard/api/v2/admin/vendingmachines/vm-cohorts`,
//         "POST",
//         payload,
//         (response) => {
//           console.log("API success response:", response);
  
//           if (response.cohortId !== undefined) {
//             console.log("Cohort success:", response);
//             props.onChange_CreateCohortSuccess(response);
//             toastr.success("Success", "Cohort created successfully");
  
//             setCohortId(response.cohortId);
//             resolve(true); 
//           } else {
//             toastr.error("Error", "Failed to create cohort");
//             resolve(false); 
//           }
//         },
//         (err) => {
//           console.error("API error response:", err);
//           toastr.error("Error", err?.message );
//           resolve(false); 
//         }
//       );
//     });
//   };
  

//   const handleCreateFranchisee = async () => {
//     validateFranchiseeFields();
//     console.log("Creating franchisee...");
//     const cohortIdValue =
//       formDataFranchisee.cohortId !== ""
//         ? parseInt(formDataFranchisee.cohortId)
//         : cohortId;
  
//     const payload = {
//       name: formDataFranchisee.name,
//       description: formDataFranchisee.description,
//       type: formDataFranchisee.type,
//       cohortId: cohortIdValue,
//       ownerId: parseInt(formDataFranchisee.ownerId),
//         warehouseId: formDataFranchisee.warehouseId ? parseInt(formDataFranchisee.warehouseId) : null, 
//     };
  
//     return new Promise((resolve) => {
//       props.getDataFromAPI(
//         `/dashboard/api/v2/admin/franchisee`,
//         "POST",
//         payload,
//         (response) => {
//           console.log("Franchisee creation response:", response);
  
//           if (response.id) {
//             const franchiseeId = response.id;
//             console.log("Franchisee ID:", franchiseeId);
//             toastr.success("Success", "Franchisee created successfully");
  
//             setFranchiseeId(franchiseeId);
//             resolve(true); 
//           } else {
//             toastr.error("Error", "Failed to create franchisee");
//             resolve(false);
//           }
//         },
//         (err) => {
//           console.error("Error creating franchisee:", err);
//           toastr.error("Error", err?.message || "An error occurred");
//           resolve(false); 
//         }
//       );
//     });
//   };

//   const handleGetMapCharges = () => {
//     const queryParams = new URLSearchParams({
//       pageSize: 100,
//       pageNumber: 0,
//       beneficiaryTypeId: 1,
//     });

//     const url = `/dashboard/api/v2/admin/platform/charge?${queryParams.toString()}`;

//     props.getDataFromAPI(
//       url,
//       "GET",
//       undefined,
//       (response) => {
//         console.log("Franchisee charges response:", response);
//         setCreateFranchiseeCharges(response);
//       },
//       (err) => {
//         console.log("error---", err);
//         toastr.error("Failed", "Unable to fetch franchisee details");
//       }
//     );
//   };

//   const handleCheckboxChange = (chargeId) => {
//     if (selectedChargeIds.includes(chargeId)) {
//       setSelectedChargeIds(selectedChargeIds.filter((id) => id !== chargeId));
//     } else {
//       setSelectedChargeIds([...selectedChargeIds, chargeId]);
//     }
//   };

//   useEffect(() => {
//     if (activeStep === 2 && !createFranchiseeCharges) {
//       handleGetMapCharges();
//     }

//     if (activeStep === 2 && createFranchiseeCharges) {
//       setSelectedChargeIds([]);
//     }
//   }, [activeStep, createFranchiseeCharges]);



  
//   const handleAssignCharges = async () => {
//     if (!franchiseeId) {
//       toastr.error("Error", "Franchisee ID is not available.");
//       return false; 
//     }
  
//     const payload = selectedChargeIds;
  
//     return new Promise((resolve) => {
//       try {
//         props.getDataFromAPI(
//           `/dashboard/api/v2/admin/platform/beneficiary/franchisee/${franchiseeId}/charge`,
//           "POST",
//           payload,
//           (response) => {
//             console.log("handleAssignCharges API response:", response);
  
//             setFranchiseeId(franchiseeId); 
//             toastr.success("Charges Applied Successfully!");
//             resolve(true); 
//           },
//           (err) => {
//             console.error("handleAssignCharges API error:", err.message);
//             toastr.error("Error", err.message || "Failed to assign charges.");
//             resolve(false); 
//           }
//         );
//       } catch (err) {
//         console.error("Unexpected error assigning charges:", err);
//         toastr.error("Error", "An unexpected error occurred.");
//         resolve(false); 
//       }
//     });
//   };
  

//   const handleBankDetails = async () => {
//     if (!validateBankDetailsFields()) {
//       return;
//     }

//     try {
//       const payload = {
//         accountName: formDataBank.accountName,
//         accountId: formDataBank.accountId,
//         ifsc: formDataBank.ifsc,
//       };

//       const response = await props.getDataFromAPI(
//         `/dashboard/api/v2/admin/franchisee/${franchiseeId}/bank-detail`,
//         "PUT",
//         payload
//       );

//       console.log("bank details creation response:", response);
//       setFranchiseeId(response.id);
//       toastr.success("Partner Created Successfully")
//       navigate("/home/configuration/managepartners");
//     } catch (err) {
//       console.log("err ankit", err);
//       toastr.error(`${err.message}`, {
       
//       });
//     }
//   };


//   useEffect(() => {
//     getWarehouseList();
//   }, []);

//   const getWarehouseList = () => {
//     props.getDataFromAPI(
//       "/partner/api/v2/warehouse/list",
//       "GET",
//       undefined,
//       (response) => {
//         console.log("warehouseData:", response);
//         setWarehouseList(response);
//       },
//       (err) => {
//         console.log("error:", err);
//         toastr.error("Failed", "Unable to fetch warehouse listing");
//       }
//     );
//   };

//   const handleChangeBankDetails = (event) => {
//     const { name, value } = event.target;
//     setFormDataBank((prevData) => ({ ...prevData, [name]: value }));
//   };

//   return (
//     <>
//       <ConfigurepayoutComponent
//         activeStep={activeStep}
//         handleNext={handleNext}
//         handleClose={handleClose}
//         handleCreateCohort={handleCreateCohort}
//         formData={formData}
//         handleChangeCohort={handleChangeCohort}
//         setFormData={setFormData}
//         handleCreateFranchisee={handleCreateFranchisee}
//         setFormDataFranchisee={setFormDataFranchisee}
//         handleChangeFranchisee={handleChangeFranchisee}
//         errors={errors}
//         createFranchiseeCharges={createFranchiseeCharges}
//         createCohortCalled={createCohortCalled}
//         handleAssignCharges={handleAssignCharges}
//         handleBankDetails={handleBankDetails}
//         cohortId={cohortId}
//         handleChangeBankDetails={handleChangeBankDetails}
//         formDataBank={formDataBank}
//         handleCheckboxChange={handleCheckboxChange}
//         selectedChargeIds={selectedChargeIds}
//         franchiseeId={franchiseeId}
//         stepCompleted={stepCompleted}
//         warehouseList={warehouseList}
//       />
//     </>
//   );
// };

// function mapStateToProps(props) {
//   return {
//     props,
//   };
// }

// export default connect(mapStateToProps, {
//   getDataFromAPI,
//   onChange_CreateCohortSuccess,
//   onChange_CreateFranchiseeSuccess,
// })(ConfigurepayoutContainer);